module.exports = __webpack_public_path__ + "static/media/foodPlate.8db2b34e.svg";